import React from "react"

import { styled } from "@mui/styles"

import { Attachment } from "./Attachment"
import { Files } from "../../types/Files"

interface IProps {
  files: Files,
  fileCount: number,
  maxAttachments: number,
  maxAttachmentSize: number,
  supportedFileTypes: string[],
  onRemove: (index: number) => void,
}

export const Attachments = ({ files, fileCount, maxAttachments, maxAttachmentSize, supportedFileTypes, onRemove }: IProps) =>
  <Wrapper>
    {
      Array
        .from(files || [])
        .map((item: File, index) =>
          <Attachment
            key={index.toString()}
            index={index}
            title={item.name}
            size={item.size}
            fileCount={fileCount}
            maxAttachments={maxAttachments}
            maxAttachmentSize={maxAttachmentSize}
            supportedFileTypes={supportedFileTypes}
            onRemove={onRemove} />
        )
    }
  </Wrapper>

const Wrapper = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: "0.8rem"
})
